import type {RouteRecordRaw} from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        path: 'logs',
        name: 'administration.logs',
        meta: {
            breadcrumb: {
                key: 'logs.entity',
                plural: 2
            }
        },
        component: () => import('@/modules/logs/views/LogsIndex.vue')
    }
]


export default routes;
